import styled from "styled-components";
import { display } from "styled-system";

export const StyledSectionWrapper = styled.div`
  background: #fff;
  padding-top: 40px;
  overflow: hidden;
  position: relative;
 
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
    padding-top: 90px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding-left: 86px;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-right: 94px;
  }
`;

export const StyledIndicators = styled.div`
  ${display};
  justify-content: center;
  margin-bottom: 62px;

  & > p {
    display: none;
  }
  
  & > h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    color: #ed3163;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin-bottom: 82px;
    align-items: center;
    
    & > p {
      display: block;
      font-weight: bold;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      color: #233247;
    }
    
    & > p:first-child {
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.0001) 35px,
        #233247
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    & > p:last-child {
      background: linear-gradient(
        to left,
        rgba(255, 255, 255, 0.0001) 40px,
        #233247
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    & > h3 {
      margin: 0 20px;
    }
  }
`;

export const StyledDescription = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 6% 0 8%;

  & > p {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 35px;
    margin-bottom: 80px;
    color: #233247;
  }
  
  & > h4 {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.161738px;
    margin-bottom: 18px;
    color: #96a8be;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 0;
    margin-left: 7%;
    max-width: 416px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin-left: 0;
    margin-right: 20px;
  }
`;

export const StyledImageWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 4% 0;
  max-width: 500px;
  margin: 0 auto -10%;
  
  & > img {
    width: 100%;
    height: auto;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    margin-bottom: -5%;
    padding-left: 0;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    max-width: 555px;
    margin: 0 0 -65px auto;
    padding: 0;
  }
`;

export const PhonesImage = styled.img.attrs(props => {
  return {
    src:
      window.innerWidth > parseInt(props.theme.queries.sl, 10)
        ? "./images/section3-phons-desctop.png"
        : "./images/section3-phons.png"
  };
})``;
